import type { ChangeEvent, ReactNode } from 'react';
import { useInstantSearch, useToggleRefinement } from 'react-instantsearch';
import { FormattedMessage } from 'react-intl';

import { BodyM } from '@sorare/core/src/atoms/typography';
import { Switch } from '@sorare/core/src/components/search/Switch';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import type { ToggleFilter as ToggleFilterType } from '@sorare/core/src/lib/filters';

import { Toggle } from 'searchCards/Toggle';

type Props = {
  icon?: ReactNode;
  filter: ToggleFilterType;
  on?: string | string[] | undefined;
  off?: string | string[] | undefined;
  autoHide?: boolean;
};
export const ToggleFilter = ({
  icon,
  filter,
  on,
  off,
  autoHide = false,
}: Props) => {
  const {
    value: {
      isRefined,
      onFacetValue: { count },
    },
    refine,
  } = useToggleRefinement({
    attribute: filter.attribute,
    on,
    off,
  });
  const { indexUiState } = useInstantSearch();
  const track = useEvents();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    track('Use Market Filter', {
      filterName: filter.attribute,
      filterValue: event.target.checked.toString(),
    });

    refine({ isRefined });
  };

  // we rather consider the refinement state from the UI
  // so that we don't rely on the Algolia answer to come back to reflect the slider state
  const optimisticRefined = !!indexUiState.toggle?.[filter.attribute];

  if (autoHide && !count) {
    return null;
  }

  return (
    <Toggle icon={icon}>
      <Switch
        checked={optimisticRefined}
        onChange={handleChange}
        label={
          <BodyM bold>
            {typeof filter.label === 'string' ? (
              filter.label
            ) : (
              <FormattedMessage {...filter.label} />
            )}
          </BodyM>
        }
      />
    </Toggle>
  );
};
